module.exports = __webpack_public_path__ + "img/3_2024_08_23.bd1127ed.jpg";